"use client";
import Image from "next/image";
import Link from "next/link";
import { Button } from "@workspace/ui/components";
import Lottie from "lottie-react";
import footerAnimation from "@/public/animations/footer.json";
import { BOOK_DEMO_URL, INSTALL_EXTENSION_URL } from "@/lib/landing-links";

export const LandingFooter = () => {
  return (
    <div className="flex flex-col pt-[148px]">
      <div className="flex items-center justify-center px-5">
        <div className="flex flex-col w-full max-w-[1144px] rounded-[32px] bg-[#f3e4c9] border border-[#e3d8c4] px-5 py-10 lg:py-[48px] items-center">
          <Lottie animationData={footerAnimation} className="mb-8" />
          <h3 className="relative text-[24px] text-d-black font-extrabold leading-[32px] text-center mb-2 lg:text-[32px] lg:mb-4 lg:leading-[40px]">
            Put a senior partner{" "}
            <span className="relative z-[2] whitespace-nowrap after:flex after:absolute after:bottom-[-2px] after:left-1/2 after:-translate-x-1/2 after:bg-[#FFD602] after:w-full after:h-4 after:min-h-4 after:z-[0] after:rounded-[6px] lg:after:bottom-1">
              <span className="z-10 relative">on every call.</span>
            </span>
          </h3>
          <p className="text-base lg:text-[22px] font-medium text-d-gray max-w-[32ch] lg:max-w-[38ch] text-center mb-10">
            Other tools grade the call after it&apos;s lost. Yolk is in the
            room while it counts.
          </p>
          <div className="flex flex-col items-center gap-4 sm:flex-row sm:gap-4">
            <Button
              asChild
              variant="d-primary"
              className="font-sfpro-rounded h-12"
            >
              <Link
                href={INSTALL_EXTENSION_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Install Free Extension
              </Link>
            </Button>
            <Button asChild variant="d-default" className="h-12">
              <Link href={BOOK_DEMO_URL}>Book A Demo</Link>
            </Button>
          </div>
        </div>
      </div>
      <footer
        className="relative flex flex-col justify-between align-bottom w-full px-5 pt-8 pb-0 gap-8 items-center md:items-center
        lg:pb-6 lg:pt-[96px] overflow-hidden lg:gap-[112px]"
      >
        <div className="flex items-center gap-5">
          <Button variant="d-ghost" className="size-[30px] p-0" asChild>
            <Link
              target="_blank"
              href="https://www.linkedin.com/company/yolk-coach"
              className="w-[30px] h-[30px]"
            >
              <Image
                src="/landing/linkedin.svg"
                alt="linkedin"
                width={24}
                height={24}
              />
            </Link>
          </Button>
          <Button variant="d-ghost" className="size-[30px] p-0" asChild>
            <Link
              target="_blank"
              href="https://x.com/YolkCoach"
              className="w-[30px] h-[30px]"
            >
              <Image
                src="/landing/x.svg"
                alt="linkedin"
                width={24}
                height={24}
                className="stroke-white"
              />
            </Link>
          </Button>
          <Button variant="d-ghost" className="size-[30px] p-0" asChild>
            <Link
              target="_blank"
              href="https://www.facebook.com/yolk.coach"
              className="w-[30px] h-[30px]"
            >
              <Image
                src="/landing/facebook.svg"
                alt="linkedin"
                width={24}
                height={24}
              />
            </Link>
          </Button>
        </div>
        <div className="flex flex-col w-full justify-between items-center gap-5 lg:flex-row max-w-[1144px]">
          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-4">
            <Button
              variant="d-ghost"
              asChild
              className="text-d-gray font-semibold leading-[22px] text-lg"
            >
              <Link href="/terms-of-use">Terms of Use</Link>
            </Button>
            <Button
              variant="d-ghost"
              asChild
              className="text-d-gray font-semibold leading-[22px] text-lg"
            >
              <Link href="/privacy-policy">Privacy Policy</Link>
            </Button>
            <Button
              variant="d-ghost"
              asChild
              className="text-d-gray font-semibold leading-[22px] text-lg"
            >
              <Link href="/dpa">Data Processing Agreement</Link>
            </Button>
          </div>
          <span className="text-d-gray text-lg font-semibold leading-[22px]">
            {`© ${new Date().getFullYear()} Yolk. All rights reserved`}
          </span>
        </div>
        <span className="text-[158px] font-extrabold leading-[158px] bg-[image:linear-gradient(180deg,#F3E4C9_0.26%,rgba(243,228,201,0.00)_90.67%)] bg-clip-text text-transparent lg:absolute lg:bottom-[-20%] lg:left-1/2 lg:-translate-x-1/2 lg:text-[218px] lg:leading-[214px]">
          Yolk
        </span>
      </footer>
    </div>
  );
};
